const grays = [
  '#E8E8E8',
  '#707070',
  '#000000CC',
  '#393739',
]

const brand = {
  offWhite: '#F4F3F2',
  darkGray: '#3E4543',
  black: '#3E4543',
  nearBlack: '#0F1312',

  turquoise: '#147B6D',
  turq50: '#9DC3C0',
  turq25: '#C7E5E2',
  turq20: '#D5ECE9',
  turq10: '#E8F4F3',

  green: '#208778',

  maroon: '#6E0404',
  darkMaroon: '#4D0202',

  yellow: '#FFA400',
  yellow50: '#FFE8BF',
  orange: '#FF8D00',
  orange50: '#FFD17F',
}

export const colors = {
  text: brand.nearBlack,
  grayText: brand.darkGray,
  background: brand.offWhite,
  primary: brand.turquoise,
  secondary: brand.darkGray,
  accent: brand.maroon,
  placeholder: brand.turq25,
  brand,
}